import {
    useCallback,
    useRef
} from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import ProfileDropdown from './Components/ProfileDropDown'
import companyInfoQuery from './Pages/Home/services/company-info'

const ENV_TO_COMPANY = {
    QA: "QA Portal",
    ADMIN: "Admin Portal",
    EXECUTIVE: "Executive Portal"
}

const envKey = process.env.REACT_APP_SELECTED_ENV

export default function Header() {
    const menuRef = useRef(null)
    const navigate = useNavigate()

    const { data: company } = useQuery({
        queryKey: ['company'],
        queryFn: companyInfoQuery,
        enabled: envKey === "HR",
    })

    const companyName = envKey === "HR"
        ? company?.name ?? ''
        : ENV_TO_COMPANY[envKey] ?? ''

    const handleNavigate = useCallback(() => {
        navigate("/")
    }, [navigate])

    return (
        <header className="w-full h-16 bg-white shadow flex items-center justify-between px-8">
            {/* Left: Logo */}
            <div
                className="flex-shrink-0 cursor-pointer"
                onClick={handleNavigate}
                role="button"
                aria-label="Go to homepage"
            >
                <img
                    src="/logo.png"
                    alt="VerifiedID Logo"
                    className="w-40 h-auto hover:opacity-80 transition-opacity duration-200"
                />
            </div>

            {/* Center: Company Name */}
            <div className="text-center mr-[15%] md:mr-[6%] lg:mr-[5%]">
                {companyName && (
                    <span
                        className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-700 px-3 py-1 rounded-xl"
                        title={companyName.replace(/\./g, "")}
                    >

                        <span className="block md:hidden">
                            {companyName.replace(/\./g, "").length > 20
                                ? companyName.replace(/\./g, "").slice(0, 20) + "…"
                                : companyName.replace(/\./g, "")}
                        </span>

                        <span className="hidden md:block">
                            {companyName.replace(/\./g, "")}
                        </span>
                    </span>
                )}
            </div>


            <div className="relative" ref={menuRef}>

                <ProfileDropdown />
            </div>
        </header>
    )
}
